import type { ReactNode } from 'react';

export function EmptyState({ message, action }: { message: string; action?: ReactNode }) {
  return (
    <div className="empty-state">
      <span className="empty-state-icon">⬡</span>
      <p className="empty-state-description">{message}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
